import { createSlice } from '@reduxjs/toolkit';

const deviceSlice = createSlice({
  name: 'device',
  initialState: {
    updatedSelectedDevice: false,
    selectedDeviceIndex: 0,
    selectedDeviceId: null,
    selectedGroupId: null,
    linkingGroupId: null, //Used to sync group in connected devices screen
    deviceSettings: null,
    groupSettings: null,
    awareOpen: false,
    usgsOpen: false,
    usgsDisclaimerAccepted: false,
  },
  reducers: {
    openDeviceSettings: (state, action) => {
      const payload = action.payload;
      const deviceId = payload && typeof payload === 'object' ? (payload.id ?? payload) : payload;
      state.selectedDeviceId = deviceId ?? null;
      state.deviceSettings =
        payload && typeof payload === 'object' && payload.deviceSettings
          ? payload.deviceSettings
          : null;
    },
    openGroupSettings: (state, action) => {
      const payload = action.payload;
      const groupId = payload && typeof payload === 'object' ? payload.id : payload;
      state.selectedGroupId = groupId ?? null;
      state.groupSettings =
        payload && typeof payload === 'object' && payload.groupSettings
          ? payload.groupSettings
          : null;
    },
    openAwareSettings: (state, action) => {
      state.selectedDeviceId = action.payload ?? null;
      state.awareOpen = true;
    },
    openUSGSSettings: (state, action) => {
      state.selectedDeviceId = action.payload;
      state.usgsOpen = true;
    },
    clearDeviceSettings: (state) => {
      state.deviceSettings = null;
      state.selectedDeviceId = null;
    },
    clearGroupSettings: (state) => {
      state.groupSettings = null;
      state.deviceSettings = null;
      state.selectedGroupId = null;
    },
    setSelectedDeviceIndex: (state, action) => {
      state.selectedDeviceIndex = action.payload;
    },
    setSelectedDeviceId: (state, action) => {
      state.selectedDeviceId = action.payload;
      if (action.payload != null) state.linkingGroupId = null; // Selecting a device clears any active group linkage.
    },
    setSelectedGroupId: (state, action) => {
      state.selectedGroupId = action.payload;
    },
    setLinkingGroupId: (state, action) => {
      state.linkingGroupId = action.payload;
      if (action.payload != null) state.selectedDeviceId = null; // Linking a group clears any active device selection.
    },
    setUpdatedSelectedDevice: (state) => {
      state.updatedSelectedDevice = !state.updatedSelectedDevice;
    },
    setAwareOpen: (state, action) => {
      state.awareOpen = action.payload;
    },
    setUSGSOpen: (state, action) => {
      state.usgsOpen = action.payload;
    },
    setUSGSDisclaimerAccepted: (state, action) => {
      state.usgsDisclaimerAccepted = action.payload;
    },
  },
});

export const {
  openDeviceSettings,
  openGroupSettings,
  openAwareSettings,
  openUSGSSettings,
  clearDeviceSettings,
  clearGroupSettings,
  setSelectedDeviceIndex,
  setSelectedDeviceId,
  setSelectedGroupId,
  setLinkingGroupId,
  setUpdatedSelectedDevice,
  setAwareOpen,
  setUSGSOpen,
  setUSGSDisclaimerAccepted,
} = deviceSlice.actions;

export default deviceSlice.reducer;
